  function detectCaption(text) {
  if (!text) return "default";

  text = text.toLowerCase();

  // GLOW
  if (text.includes("glow") || text.includes("shine") || text.includes("bright"))
    return "glow";

  // LOVE
  if (
    text.includes("love") ||
    text.includes("heart") ||
    text.includes("💖") ||
    text.includes("❤️")
  )
    return "love";

  // CLASSY
  if (
    text.includes("classy") ||
    text.includes("luxury") ||
    text.includes("elegant") ||
    text.includes("💎")
  )
    return "classy";

  // BOLD
  if (
    text.includes("bold") ||
    text.includes("fearless") ||
    text.includes("brave") ||
    text.includes("⚡")
  )
    return "bold";

  // VIBES
  if (
    text.includes("vibe") ||
    text.includes("vibes") ||
    text.includes("energy") ||
    text.includes("✨")
  )
    return "vibes";

  // MOTIVATION
  if (
    text.includes("dream") ||
    text.includes("grind") ||
    text.includes("goal") ||
    text.includes("make it happen") ||
    text.includes("plan") ||
    text.includes("hustle")
  )
    return "motivation";

  // SHINE (extra category)
  if (text.includes("shine") || text.includes("shining")) return "shine";

  // SUNSET
  if (
    text.includes("sunset") ||
    text.includes("sunrise") ||
    text.includes("🌅") ||
    text.includes("golden hour")
  )
    return "sunset";

  // SELF LOVE
  if (
    text.includes("self-love") ||
    text.includes("self care") ||
    text.includes("selflove") ||
    text.includes("self care") ||
    text.includes("🧘")
  )
    return "selflove";

  // UNSTOPPABLE
  if (
    text.includes("unstoppable") ||
    text.includes("no limits") ||
    text.includes("can't stop") ||
    text.includes("won't stop")
  )
    return "unstoppable";

  // WEEKEND
  if (
    text.includes("weekend") ||
    text.includes("sunday") ||
    text.includes("saturday") ||
    text.includes("😎")
  )
    return "weekend";

  // CONFIDENCE
  if (
    text.includes("confidence") ||
    text.includes("queen energy") ||
    text.includes("boss mode") ||
    text.includes("👑")
  )
    return "confidence";

  // HUSTLE
  if (
    text.includes("hustle") ||
    text.includes("grind") ||
    text.includes("work mode") ||
    text.includes("💼")
  )
    return "hustle";

  // POSITIVITY
  if (
    text.includes("positive") ||
    text.includes("radiate") ||
    text.includes("good vibes") ||
    text.includes("🌞")
  )
    return "positivity";

  // AESTHETIC
  if (
    text.includes("vibe with it") ||
    text.includes("moon child") ||
    text.includes("aesthetic") ||
    text.includes("🌙")
  )
    return "aesthetic";

  // TRAVEL
  if (
    text.includes("adventure") ||
    text.includes("travel") ||
    text.includes("wanderlust") ||
    text.includes("🌍")
  )
    return "travel";

  // QUOTES
  if (
    text.includes("life's too short") ||
    text.includes("quote") ||
    text.includes("therapy") ||
    text.includes("📖")
  )
    return "quotes";

  return "default";
}

export {detectCaption}